import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import form from "./option-form/option-form";

let mod = angular
    .module('DirectionOptionsControl.component', [angularUIB, form])
    .component('directionOptionsControl', {
        controller: ['$http', '$uibModal', 'Data', 'notifier', controller],
        template: require('./direction-options-control.component.html'),
        bindings: {
            direction: '<'
        }
    });

function controller($http, $uibModal, Data, notifier) {

    let $ctrl = this;

    $ctrl.openForm = function (option, ind) {
        $uibModal
            .open({
                component: 'optionForm',
                size: 'lg',
                resolve: {
                    direction: function () {
                        return $ctrl.direction
                    },
                    option: function () {
                        return option;
                    }
                }
            })
            .result
            .then(function (opt) {
                if (option) {
                    $ctrl.direction.options[ind] = opt;
                } else {
                    $ctrl.direction.options.push(opt);
                }
            });
    };

    $ctrl.delOption = function (option, ind) {
        if (confirm('Вы действительно хотите удалить вариант?')) {
            $http
                .post(`/control-panel/directions/${$ctrl.direction.id}/options/${option.id}`, {_method: 'DELETE'})
                .then(function () {
                    $ctrl.direction.options.splice(ind, 1);
                });
        }
    };

    $ctrl.savePriority = function (option) {
        $http
            .post(`/control-panel/directions/${$ctrl.direction.id}/options/${option.id}/set-priority`, {
                priority: option.priority
            })
            .then(function (response) {
                $ctrl.direction.options.sort(function (a, b) {
                    return +b.priority - +a.priority;
                })
            });
    };
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/direction-options-control/direction-options-control.component.js